export const productionStepQueryKeys = {
  all: ['article', 'config', 'production', 'step'] as const,
  step: (productionStepId: number) =>
    [...productionStepQueryKeys.all, productionStepId] as const,
  materialConditionsList: (productionStepId: number) =>
    [...productionStepQueryKeys.step(productionStepId), 'material', 'conditions'] as const,
};
